"use client"

import { useEffect, useState } from "react"
import { Container, Row, Col, Card } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import "./ShopByCategory.css"

const API_URL = "https://madhusewingmachines.com/api/categories"

const ShopByCategory = () => {
  const navigate = useNavigate()
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${API_URL}/getcategory`)
        setCategories(response.data)
      } catch (error) {
        setError(error.message)
      } finally {
        setLoading(false)
      }
    }

    fetchCategories()
  }, [])

  const handleCategoryClick = (categoryName) => {
    navigate("/productpage", {
      state: { categoryFilter: categoryName },
    })
  }

  if (loading) return <div className="text-center py-5">Loading...</div>
  if (error) return <div className="text-center text-danger py-5">Error: {error}</div>

  return (
    <div style={{ backgroundColor: "#EFFBFF", minHeight: "35vh" }}>
      <Container className="text-center py-5">
        <h2 className="category-heading">🛍️ Shop by Category 🛒</h2>

        <Row className="g-4 justify-content-center">
          {categories.map((category, index) => (
            <Col
              key={category._id}
              xs={10}
              sm={6}
              md={4}
              lg={3}
              style={{
                animation: "fadeIn 0.6s ease forwards",
                animationDelay: `${index * 0.2}s`,
                opacity: 0,
              }}
            >
              <Card
                className="h-100 border-0 shadow-lg category-card"
                style={{
                  borderRadius: "15px",
                  overflow: "hidden",
                  cursor: "pointer",
                  transition: "transform 0.3s ease-in-out",
                }}
                onClick={() => handleCategoryClick(category.name)}
              >
                <div className="category-card-imgwrap" style={{ height: "210px", overflow: "hidden", marginBottom: "5px" }}>
                  <Card.Img
                    variant="top"
                    src={`https://madhusewingmachines.com/uploads/${category.categoryimg}`}
                    className="w-100 h-100 category-card-img"
                    style={{
                      objectFit: "contain",
                      borderRadius: "0",
                    }}
                  />
                </div>
                <Card.Body
                  className="text-white text-center"
                  style={{
                    background: "linear-gradient(135deg, #3498db, #85c1e9)",
                    padding: "14px",
                    fontWeight: "bold",
                    borderRadius: "0 0 15px 15px",
                    letterSpacing: "0.5px",
                  }}
                >
                  <Card.Title className="category-card-title" style={{ fontSize: "18px", textTransform: "capitalize" }}>{category.name}</Card.Title>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Inline keyframes for fade-in */}
      <style>{`
        @keyframes fadeIn {
          0% {
            transform: translateY(20px);
            opacity: 0;
          }
          100% {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  )
}

export default ShopByCategory
